module.exports = __webpack_public_path__ + "img/upgrade2.0d275a76.png";